import { useUsage } from '@/hooks/useUsage'
import { UsageBar } from './UsageBar'
import { Badge } from '@/components/ui/badge'

export function UsageDashboard() {
  const { data: usage, isLoading } = useUsage()

  if (isLoading || !usage) {
    return (
      <div className="space-y-4 motion-safe:animate-pulse">
        <div className="h-4 w-48 bg-muted rounded" />
        <div className="h-2 w-full bg-muted rounded" />
        <div className="h-2 w-full bg-muted rounded" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Tier Header */}
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-medium text-muted-foreground">Plan</h3>
        <Badge variant="secondary">{usage.tier.display_name}</Badge>
        {usage.tier.is_beta && (
          <span className="text-xs text-muted-foreground">(unlimited during beta)</span>
        )}
      </div>

      {/* Global Usage */}
      <div className="space-y-3">
        <UsageBar label="Projects" usage={usage.usage.projects} />
        <UsageBar label="Total Clips" usage={usage.usage.total_clips} />
      </div>

      {/* Per-Project Breakdown */}
      {usage.per_project.length > 0 && (
        <div className="space-y-4">
          <h4 className="text-sm font-medium text-muted-foreground">Per Project</h4>
          {usage.per_project.map((proj) => (
            <div key={proj.project_id} className="space-y-2 rounded-lg border p-3">
              <p className="text-sm font-medium truncate">{proj.project_name}</p>
              <UsageBar label="Commits" usage={proj.commits} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
